import React from 'react';
import { arrayOf, node, oneOfType, string } from 'prop-types';
import { Delivery } from '@one-thd/sui-icons';
import './learn-more.scss';

export const LearnMore = ({ icon, title, children, link }) => {

  return (
    <div className="learn-more">
      <div className="learn-more__icon">
        {icon}
      </div>
      <div className="u__bold">{title}</div>
      {children}
      <a href={link} className="u__default-link">Learn More</a>
    </div>
  );
};

LearnMore.displayName = 'LearnMore';

LearnMore.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
  icon: node.isRequired,
  link: string.isRequired,
  title: string.isRequired
};

LearnMore.defaultProps = {
  children: null
};
